import { render, staticRenderFns } from "./SimpleSignUp.vue?vue&type=template&id=c410aca0&scoped=true"
import script from "./SimpleSignUp.vue?vue&type=script&lang=js"
export * from "./SimpleSignUp.vue?vue&type=script&lang=js"
import style0 from "./SimpleSignUp.vue?vue&type=style&index=0&id=c410aca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c410aca0",
  null
  
)

export default component.exports